import { IconButton } from '@mui/material';
import { PriorityItemDto } from '../../api';
import ContentCopyRoundedIcon from '@mui/icons-material/ContentCopyRounded';
import { useState } from 'react';
import { LightToolTip } from '../../components/form/react-hook-form-components/ToolTipTheme';
import ReassignPriorityPopup from '../../components/form/popups/ReassignPriorityPopup';

export interface IMoveCopyPriorityProps {
  priority: PriorityItemDto;
}

function MoveCopyPriorityButton(props: IMoveCopyPriorityProps) {
  const { priority } = props;
  const [isMoveCopyFormOpen, setIsMoveCopyFormOpen] = useState(false);

  return (
    <div>
      <LightToolTip title="Move/Copy" placement="bottom">
        <IconButton color="primary" onClick={() => setIsMoveCopyFormOpen(true)}>
          <ContentCopyRoundedIcon />
        </IconButton>
      </LightToolTip>

      <ReassignPriorityPopup
        isOpen={isMoveCopyFormOpen}
        setIsOpen={setIsMoveCopyFormOpen}
        priority={priority}
        onSuccess={() => {
          setIsMoveCopyFormOpen(false);
        }}
      />
    </div>
  );
}

export default MoveCopyPriorityButton;
